module.exports = __webpack_public_path__ + "static/media/login-icon-password.49e1df41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-icon-password.svg
// module id = 1107
// module chunks = 0